import Vue from "vue";
import Vuex from "vuex";

import actions, { publicActions } from "./actions";
import getters, { publicGetters } from "./getters";
import mutations, { publicMutations } from "./mutations";
import state from "./state";

Vue.use(Vuex);

const store = new Vuex.Store({
    state,
    getters,
    mutations,
    actions
});

export {
    store as default,
    publicActions as vuexActions,
    publicGetters as vuexGetters,
    publicMutations as vuexMutations
};